/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { CopilotSettings, UpdateConsentParams } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class CopilotSettingsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags copilot-settings-controller
   * @name UpdateConsent
   * @request POST:/api/v1/copilot/settings/consent
   */
  updateConsent = (query: UpdateConsentParams, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/copilot/settings/consent`,
      method: 'POST',
      query: query,
      ...params,
    })

  static updateConsentPath = '/v1/copilot/settings/consent'
  static updateConsentMethod = 'POST'
  /**
   * No description
   *
   * @tags copilot-settings-controller
   * @name GetSettings
   * @request GET:/api/v1/copilot/settings
   */
  getSettings = (params: RequestParams = {}) =>
    this.http.request<CopilotSettings, any>({
      path: `/v1/copilot/settings`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getSettingsPath = '/v1/copilot/settings'
  static getSettingsMethod = 'GET'
}
